module.exports = __webpack_public_path__ + "65fe235cb2ea685736d3f855ed53c653.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/vibo_vibo-white-new.png
// module id = 573
// module chunks = 16